// extracted by mini-css-extract-plugin
export default {"background":"modal_background__IGWhl","modalSize":"modal_modalSize__j+fO4","btn":"modal_btn__egyQU","btn-primary":"modal_btn-primary__BJA8x","titleWhite":"modal_titleWhite__bNPL7"};